$( document ).on('turbolinks:load', function() {
  if($('body').hasClass('leeds-index')){
    $('.checkbox_ignore_ia').click(function() {
      const checkbox = $(this)
      const whatsapp_number = checkbox.parent().find('.whatsapp_number').val().replace(/[^0-9]/g, '')
      const instance_id = $("#whatsapp_instance_id").val() || 'all'
      const action = checkbox.is(':checked') ? 'add' : 'del'

      checkbox.prop('disabled', true)
      $.post("/whatsapp_ignore_ia_" + action, {
        whatsapp_number: whatsapp_number,
        whatsapp_instance_id: instance_id
      }).done(function(data) {
        if (!data.status) checkbox.prop('checked', !checkbox.is(':checked'))
      }).fail(function() {
        checkbox.prop('checked', !checkbox.is(':checked'))
        alert('Não foi possível atualizar a opção Ignorar IA. Tente novamente.')
      }).always(function() {
        checkbox.prop('disabled', false)
      })
    });
    $('.checkbox_ignore_folowup').click(function() {
      let whatsapp_number = $(this).parent().find('.whatsapp_number').val().replace(/[^0-9]/g, '')
      console.log(whatsapp_number)
      if ($(this).is(':checked')) {
        $.post("/whatsapp_ignore_followup_add?whatsapp_number=" + whatsapp_number + "&whatsapp_instance_id=" + $("#whatsapp_instance_id").val(), function(data, status){
          if(data.status){

          }
        });
      }else{
        $.post("/whatsapp_ignore_followup_del?whatsapp_number=" + whatsapp_number + "&whatsapp_instance_id=" + $("#whatsapp_instance_id").val(), function(data, status){
          if(data.status){

          }
        });
      }
    });
  }
})
